import { Injectable } from '@angular/core';

import { LogService, AppContext } from './../../shared';

@Injectable()
export class BlurService {
  type: string = 'date'; // default
  item: any = null;
  text: string = '';
  showText: boolean = false;

  url: string = '';

  // arrays of image urls
  dates: Array<string> = ['../img/blurredtext-dark.png'];
  largeText: Array<string> = ['../img/blurredtext-large.png'];
  mediumText: Array<string> = ['../img/blurredtext-medium.png'];
  smallText: Array<string> = ['../img/blurredtext-small.png'];
  largeNumber: Array<string> = ['../img/4numbers.png', '../img/4numbersv2.png',
    '../img/4numbersv3.png', '../img/4numbersv4.png',
    '../img/5numbers.png', '../img/5numbersv2.png',
    '../img/5numbersv3.png', '../img/5numbersv4.png'];
  mediumNumber: Array<string> = ['../img/3numbers.png', '../img/3numbersv2.png',
    '../img/3numbersv3.png', '../img/3numbersv4.png'];
  smallNumber: Array<string> = ['../img/2numbers.png', '../img/2numbersv2.png',
    '../img/2numbersv3.png', '../img/2numbersv4.png'];
  darkText: Array<string> = ['../img/blurredtext-dark.png'];
  largeTextDark: Array<string> = ['../img/blurredtext-large-dark.png'];
  mediumTextDark: Array<string> = ['../img/blurredtext-medium-dark.png'];
  smallTextDark: Array<string> = ['../img/blurredtext-small-dark.png'];
  largeNumberDark: Array<string> = ['../img/4numbers-dark.png', '../img/4numbersv2-dark.png',
    '../img/4numbersv3-dark.png', '../img/4numbersv4-dark.png',
    '../img/5numbers-dark.png', '../img/5numbersv2-dark.png',
    '../img/5numbersv3-dark.png', '../img/5numbersv4-dark.png'];
  mediumNumberDark: Array<string> = ['../img/3numbers-dark.png', '../img/3numbersv2-dark.png',
    '../img/3numbersv3-dark.png', '../img/3numbersv4-dark.png'];
  smallNumberDark: Array<string> = ['../img/2numbers-dark.png', '../img/2numbersv2-dark.png',
    '../img/2numbersv3-dark.png', '../img/2numbersv4-dark.png'];


  constructor(private logger: LogService, public app: AppContext) {
    // this.logger.log('search-box.service', 'constructor', this.app);
  }

  upsell() {
    if (!this.app.isLoggedIn) {
      this.app.showRegister();
    } else if (this.app.accountType === 'Premium') {
      this.app.showUpgrade();
    }
  }

  setType(type: string) {
    this.type = type;

    switch (this.type) {
      case 'date':
        this.setUrl(this.dates);
        break;
      case 'carrier':
        this.setUrl(this.largeText);
        break;
      case 'port':
        this.setUrl(this.largeTextDark);
        break;
      case 'vessel':
        this.setUrl(this.largeTextDark.concat(this.mediumTextDark));
        break;
      case 'phone':
        this.setUrl(this.largeNumber);
        break;
      case 'website':
        this.setUrl(this.largeText);
        break;
      case 'text':
        this.setUrl(this.largeText.concat(this.mediumText, this.smallText));
        break;
      case 'text-dark':
        this.setUrl(this.largeTextDark.concat(this.mediumTextDark, this.smallTextDark));
        break;
      case 'large-text':
        this.setUrl(this.largeText);
        break;
      case 'large-number':
        this.setUrl(this.largeNumber);
        break;
      case 'medium-number':
        this.setUrl(this.mediumNumber);
        break;
      case 'medium-text':
        this.setUrl(this.mediumText);
        break;
      case 'small-text':
        this.setUrl(this.smallText);
        break;
      case 'small-number':
        this.setUrl(this.smallNumber);
        break;
      case 'dark-text':
        this.setUrl(this.darkText);
        break;
      case 'large-text-dark':
        this.setUrl(this.largeTextDark);
        break;
      case 'medium-text-dark':
        this.setUrl(this.mediumTextDark);
        break;
      case 'small-text-dark':
        this.setUrl(this.smallTextDark);
        break;
      case 'large-number-dark':
        this.setUrl(this.largeNumberDark);
        break;
      case 'medium-number-dark':
        this.setUrl(this.mediumNumberDark);
        break;
      case 'small-number-dark':
        this.setUrl(this.smallNumberDark);
        break;
      default:
        this.setUrl(this.largeText.concat(this.mediumText, this.smallText));
        break;
    }
  }

  setItem(item: any) {
    try {
      this.item = item;

      if (this.type === 'carrier') {
        this.text = this.item.name;
      } else if (this.type === 'port') {
        this.text = this.item.title;
      } else if (this.type === 'vessel') {
        this.text = this.item.name;
      } else if (this.type === 'website') {
        this.text = this.item.url;
      } else {
        this.text = +item === NaN ? item : item.toString(); // check if number
      }
      this.showText = this.text.toLowerCase() !== 'blurred text';
    } catch (ex) {
      this.text = '';
      this.showText = true;
    }
  }

  setUrl(urls: Array<string>) {
    let index = Math.floor(Math.random() * (urls.length - 1));
    this.url = urls[index];
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/blur/blur.service.ts